// extracted by mini-css-extract-plugin
module.exports = {"room-link":"_02712f2b3b--room-link--R6fnW","link":"_02712f2b3b--link--Rxk7T"};